import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import NbisDateTimePickerComponent from "presentation/view/components/NbisDateTimePickerComponent";
import { useMemo } from "react";

export const RFInfoAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();

    const hideRfhInfoField = useMemo(() => {
        const chargeTypeList = chargeBatchUpdate.tmpChargeTypeSubChargeType ?? [];
        const ret = chargeTypeList.some(type => type !== 'RFH');
        if (ret) {
            return true;
        } else {
            return false;
        }
    }, [chargeBatchUpdate.tmpChargeTypeSubChargeType])

    return (
        <>
            {!hideRfhInfoField && <>
                <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                    <div className='im-flex-row-item'>
                        <NbisDateTimePickerComponent
                            label='Create Date/Time'
                            disabled={false}
                            width='330px'
                            date={chargeBatchUpdate.createDatetime}
                            onDateChange={chargeDetailVM.onDatePickerChange}
                            fieldName={"createDatetime"} />
                    </div>
                </div>

                <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                    <div className='im-flex-row-item'>
                        <NbisDateTimePickerComponent
                            label='Req. Pickup Date/Time'
                            disabled={false}
                            width='330px'
                            date={chargeBatchUpdate.reqPickupDatetime}
                            onDateChange={chargeDetailVM.onDatePickerChange}
                            fieldName={"reqPickupDatetime"} />
                    </div>
                </div>

                <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                    <div className='im-flex-row-item'>
                        <NbisDateTimePickerComponent
                            label='Power Plug-On Date/Time'
                            disabled={false}
                            width='330px'
                            date={chargeBatchUpdate.plugOnDatetime}
                            onDateChange={chargeDetailVM.onDatePickerChange}
                            fieldName={"plugOnDatetime"} />
                    </div>
                </div>

                <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                    <div className='im-flex-row-item'>
                        <NbisDateTimePickerComponent
                            label='Power Plug-Off Date/Time'
                            disabled={false}
                            width='330px'
                            date={chargeBatchUpdate.plugOffDatetime}
                            onDateChange={chargeDetailVM.onDatePickerChange}
                            fieldName={"plugOffDatetime"} />
                    </div>
                </div>

                <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                    <div className='im-flex-row-item'>
                        <NbisDateTimePickerComponent
                            label='Power Cons. Start Date/Time'
                            disabled={false}
                            width='330px'
                            date={chargeBatchUpdate.consStartDatetime}
                            onDateChange={chargeDetailVM.onDatePickerChange}
                            fieldName={"consStartDatetime"} />
                    </div>
                </div>

                <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                    <div className='im-flex-row-item'>
                        <NbisDateTimePickerComponent
                            label='Power Cons. End Date/Time'
                            disabled={false}
                            width='330px'
                            date={chargeBatchUpdate.consEndDatetime}
                            onDateChange={chargeDetailVM.onDatePickerChange}
                            fieldName={"consEndDatetime"} />
                    </div>
                </div></>}
        </>
    )
}